import { getStore } from '../store/store';
import { mutator, mutatorAction } from 'satcheljs';
import {
    updateTimeSuggestions,
    setLastFindMeetingTimesRequestId,
    setLastFindMeetingTimesRequestDate,
} from '../actions/internalActions';
import { setCalendarComponent } from '../actions/publicActions';

mutator(updateTimeSuggestions, actionMessage => {
    const store = getStore();
    store.timeSuggestions = actionMessage.timeSuggestions;
});

mutator(setLastFindMeetingTimesRequestId, actionMessage => {
    const store = getStore();
    store.lastFindMeetingTimesRequestId = actionMessage.lastFindMeetingTimesRequestId;
});

mutator(setLastFindMeetingTimesRequestDate, actionMessage => {
    const store = getStore();
    store.lastFindMeetingTimesRequestDate = actionMessage.lastFindMeetingTimesRequestDate;
});

mutator(setCalendarComponent, actionMessage => {
    const store = getStore();
    store.calendarComponent = actionMessage.calendarComponent;
});

export const setShouldAdjustStartTimeEndTime = mutatorAction(
    'setShouldAdjustStartTimeEndTime',
    (shouldAdjustStartTimeEndTime: boolean) => {
        const store = getStore();
        store.shouldAdjustStartTimeEndTime = shouldAdjustStartTimeEndTime;
    }
);
